import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { FreeAuthProvider } from './FreeAuth';
import FreeLanding from './FreeLanding';
import FreeVerify from './FreeVerify';
import FreeLayout from './FreeLayout';
import FreeDashboard from './FreeDashboard';
import FreeLogSession from './FreeLogSession';
import FreeProgress from './FreeProgress';
import FreeSessionDetail from './FreeSessionDetail';
import FreeTechnique from './FreeTechnique';
import FreeCalculator from './FreeCalculator';
import FreeAccount from './FreeAccount';
import FreeAccountDeleted from './FreeAccountDeleted';
import DebugReadout from './DebugReadout';

export default function FreeTier() {
  return (
    <div className="min-h-screen bg-mono-base" data-testid="free-tier-root">
      <FreeAuthProvider>
        <DebugReadout />
        <Routes>
          <Route path="/free">
            <Route index element={<FreeLanding />} />
            <Route path="verify" element={<FreeVerify />} />
            <Route path="account-deleted" element={<FreeAccountDeleted />} />
            <Route element={<FreeLayout />}>
              <Route path="dashboard" element={<FreeDashboard />} />
              <Route path="log" element={<FreeLogSession />} />
              <Route path="progress" element={<FreeProgress />} />
              <Route path="session/:id" element={<FreeSessionDetail />} />
              <Route path="technique" element={<FreeTechnique />} />
              <Route path="calculator" element={<FreeCalculator />} />
              <Route path="account" element={<FreeAccount />} />
            </Route>
          </Route>
        </Routes>
      </FreeAuthProvider>
    </div>
  );
}
